import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import NotFoundImage from "../../assets/img/illustrations/404.svg";
import { Routess } from "../../Routes/routes";


export const NotFound = () => {
  return (
    <main>
      <section className="min-h-screen flex items-center justify-center bg-light">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center text-center">
            <Link to={Routess.DashboardOverview.path} className="mb-8 block transform hover:scale-105 transition-transform">
              <img src={NotFoundImage} className="w-3/4 max-w-lg mx-auto h-auto" alt="404 Not Found" />
            </Link>
            <h1 className="text-primary mt-5 text-4xl lg:text-5xl font-bold">
              Page not <span className="font-extrabold">found</span>
            </h1>
            <p className="text-gray text-lg my-6 max-w-2xl leading-relaxed">
              Oops! Looks like you followed a bad link. If you think this is a
              problem with us, please tell us.
            </p>
            <Link
              to={Routess.DashboardOverview.path}
              className="inline-flex items-center px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-blue-700 hover:-translate-y-0.5 transition-all text-base"
            >
              <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
              Go back home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};
